import { Fragment } from 'react';
import styles from './Tabs.module.scss';

interface IProps {
  items: {
    text: string;
    selected: boolean;
  }[];
  onSelect: (index: number) => void;
}

export const Tabs = ({ items, onSelect }: IProps) => {
  return (
    <div className={styles.tabs}>
      {items.map((item, index) => (
        <Fragment key={`${item.text}-${index}`}>
          <button
            className={`${styles.tabsItem} ${item.selected ? styles.tabsItemSelected : ''}`}
            onClick={() => onSelect(index)}>
            {item.text}
          </button>
          {index < items.length - 1 && !item.selected && !items[index + 1]?.selected && (
            <div className={styles.tabsItemSeparator} />
          )}
        </Fragment>
      ))}
    </div>
  );
};
